module.exports = __webpack_public_path__ + "img/logo_left_sidebar.b85c7ae4.svg";